export function toTitleCase(text) {
    if (!text)
        throw new Error('No text supplied');
    return text.toLowerCase().split(' ').map(function (word) {
        return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}
